import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, SharedClientCentricContentShareAssignmentDTO } from 'src/app/services/api/api';
import { SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-device-details-content-share',
  templateUrl: './device-details-content-share.component.html',
  styleUrls: ['./device-details-content-share.component.scss'],
  standalone: false,
})
export class DeviceDetailsContentShareComponent implements OnInit {
  deviceId: number;
  contentShareAssignment: SharedClientCentricContentShareAssignmentDTO[];

  loading: boolean = true;

  debounceTimer: ReturnType<typeof setTimeout> = null;

  // tslint:disable-next-line:variable-name
  _from?: SbLocalDateTime;
  get from(): SbLocalDateTime {
    return this._from;
  }

  set from(val) {
    this._from = val;
  }

  // tslint:disable-next-line:variable-name
  _till?: SbLocalDateTime;
  get till(): SbLocalDateTime {
    return this._till;
  }

  set till(val) {
    this._till = val;
  }

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    const defaultTime: SbLocalDateTime = new SbLocalDateTime(DateTime.now());
    this.api
      .ss_nm_Network_retrieveAllSharedContentShareAssignments({
        device: [this.deviceId],
        from: this.from ?? defaultTime,
        till: this.till ?? defaultTime,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: SharedClientCentricContentShareAssignmentDTO[]) => {
          this.contentShareAssignment = e;
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  handleDateChangeFrom(date: SbLocalDateTime) {
    this.from = date;
  }

  handleDateChangeTill(date: SbLocalDateTime) {
    this.till = date;
  }
}
